import { initPager } from './pager/pager';

export function initDemo1(){
    //passing the panel class name
    initPager('.panel--demo1');
}

